var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#282F35;}\n\t.st1{fill:#B3D2FF;}\n\t.st2{fill:#8ABCF9;}\n\t.st3{fill:#FAFAFA;}\n\t.st4{fill:#EDE8E4;}\n\t.st5{fill:#59A4EF;}\n\t.st6{fill:#DBD1C8;}\n\t.st7{fill:#3C99E5;}\n\t.st8{fill:#70B773;}\n\t.st9{opacity:0.2;fill:#424242;}\n\t.st10{fill:#FF3F62;}\n\t.st11{fill:#C61469;}\n\t.st12{fill:#FBFBFB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.6,525.9l-57.7,76.5c-4.7,6.2,2.6,11.3,16.5,11.3h494.2c13.8,0,21.1-5.2,16.5-11.3l-57.7-76.5 c-2.8-3.7-13.2-6.5-23.4-6.5H221C210.8,519.4,200.4,522.3,197.6,525.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.1,276c5.1,0,9.3,4.2,9.3,9.3h-18.6C254.8,280.1,259,276,264.1,276z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.4,268.3c9.4,0,17,7.6,17,17h-34C273.4,275.9,281,268.3,290.4,268.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.8,361.6c5.1,0,9.3,4.2,9.3,9.3h-18.6C474.5,365.7,478.7,361.6,483.8,361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M510.1,353.9c9.4,0,17,7.6,17,17h-34C493.1,361.5,500.7,353.9,510.1,353.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M574.5,334.7c5.1,0,9.3,4.2,9.3,9.3h-18.6C565.3,338.9,569.4,334.7,574.5,334.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M600.8,327c9.4,0,17,7.6,17,17h-34C583.8,334.6,591.4,327,600.8,327z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M766.6,555.4v-21.1h-14.4l-67.3-89.2c-3.8-5.1-18.3-9.1-32.4-9.1H147.6c-14.1,0-28.6,4-32.4,9.1l-67.3,89.2 H33.4v22.1h0c0.5,5.9,9.9,10.2,24.7,10.2h683.7C757.5,566.6,767.1,561.8,766.6,555.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.2,422.9L35.3,528.7c-6.4,8.5,3.7,15.7,22.8,15.7h683.7c19.1,0,29.2-7.2,22.8-15.7l-79.8-105.8 c-3.8-5.1-18.3-9.1-32.4-9.1H147.6C133.5,413.8,119,417.8,115.2,422.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "691.8,537.8 108.2,537.8 179.5,417.5 620.5,417.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M255.2,451.1l-8.6,24.2h94.1l4.1-29.8h-73C269.5,448.4,262.9,450.6,255.2,451.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.7,417.5h-81.4l-7.2,20.3c7.1,0.5,12.1,2.6,12.6,5.3h72.5L348.7,417.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M265.8,444.3c0.8-2.4-3.7-4.3-9.9-4.3c-6.3,0-12.1,1.9-13.1,4.3c-0.9,2.4,3.5,4.3,9.9,4.3 C259.1,448.7,265,446.7,265.8,444.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M294.4,433.7c0.4-1.6-2.8-2.9-7.1-2.9c-4.3,0-8.3,1.3-8.8,2.9c-0.5,1.6,2.7,2.9,7.1,2.9 S294,435.3,294.4,433.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "238.2,478.3 143.5,478.3 134.8,492.9 232.8,492.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "351.9,443.1 453.2,443.1 449.7,417.5 355,417.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "457.9,478.3 245.5,478.3 230,521.7 463.7,521.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "584.7,417.5 519.2,417.5 537.8,475.3 613.4,475.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M162.9,445.6l-17.6,29.8h94.1l9-24.2c-7.3-0.5-12.3-2.8-12.5-5.5H162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M260.9,417.5h-81.4l-15.2,25.6h72.5c2.5-2.7,9.1-4.8,16.5-5.3L260.9,417.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "453.5,445.6 351.5,445.6 347.9,475.3 457.5,475.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "228.7,525.3 224.3,537.8 465.8,537.8 464.2,525.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "465.2,478.3 474.2,537.8 549.5,537.8 531.4,478.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "132.9,496.1 108.2,537.8 216,537.8 231.6,496.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "538.7,478.3 557.8,537.8 644.4,537.8 614.8,478.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "652.7,537.8 691.8,537.8 678.7,515.7 641.3,515.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "639.6,512.2 676.6,512.2 656.5,478.3 622.2,478.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "620.6,475.3 654.8,475.3 620.5,417.5 590.9,417.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "520.7,443.1 512.9,417.5 456,417.5 459.9,443.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "521.5,445.6 460.3,445.6 464.8,475.3 530.5,475.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "618.9,486.5 541.3,486.5 538.7,478.3 614.8,478.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M165.1,458.6c-1.9,0-3.7,0.6-4.2,1.3c-0.4,0.7,0.8,1.3,2.7,1.3c1.9,0,3.8-0.6,4.2-1.3 C168.1,459.2,166.9,458.6,165.1,458.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M179.2,458.6c-1.9,0-3.7,0.6-4.1,1.3c-0.4,0.7,0.8,1.3,2.7,1.3s3.7-0.6,4.1-1.3 C182.3,459.2,181.1,458.6,179.2,458.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M193.3,458.6c-1.9,0-3.7,0.6-4.1,1.3c-0.4,0.7,0.9,1.3,2.7,1.3c1.9,0,3.7-0.6,4.1-1.3 C196.4,459.2,195.2,458.6,193.3,458.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M207.4,458.6c-1.9,0-3.7,0.6-4,1.3c-0.3,0.7,0.9,1.3,2.8,1.3c1.9,0,3.7-0.6,4-1.3 C210.6,459.2,209.3,458.6,207.4,458.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.5,458.6c-1.9,0-3.7,0.6-4,1.3c-0.3,0.7,0.9,1.3,2.8,1.3s3.7-0.6,4-1.3 C224.7,459.2,223.4,458.6,221.5,458.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M235.7,458.6c-1.9,0-3.6,0.6-3.9,1.3c-0.3,0.7,1,1.3,2.9,1.3c1.9,0,3.6-0.6,3.9-1.3 C238.8,459.2,237.5,458.6,235.7,458.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "620.6,475.3 654.8,475.3 639,448.7 607,448.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "143.6,490 148.7,481.1 230.3,481.1 226.8,490  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "404.6,440.7 404.3,419.5 444.1,419.5 446.6,440.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "355,472.6 357.6,448 386.9,448 386.1,472.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "303.5,472.6 309.1,448 338.1,448 334.3,472.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "481.4,534.3 475.9,501.3 531.2,501.3 540.7,534.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "474.5,492.9 472.9,483.3 526,483.3 528.8,492.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "118,534.3 138.3,499.1 223.3,499.1 209.6,534.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "658.6,534.3 650.5,519 673.1,519 682,534.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "645.2,509 630.5,481.1 651.3,481.1 667.4,509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "609.6,441.7 597.9,419.5 615.8,419.5 628.6,441.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "465.8,440.7 464,429.8 510.6,429.8 513.7,440.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "471.1,472.6 468,453.8 517.5,453.8 522.9,472.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "153.6,472.6 233.6,472.6 236.9,464.1 158.5,464.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "224,448 167.8,448 163.3,455.8 220.6,455.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "281.5,448 260,455.8 258.2,461.2 294.8,461.2 298.2,448  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "213.6,434.4 220.8,419.5 254.3,419.5 248.5,434.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "204.9,419.5 184.2,419.5 172,440.7 193.9,440.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "272.4,419.5 269.9,426.8 307.4,426.8 304,440.7 339.2,440.7 342.5,419.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "254.3,472.6 257.2,464.1 294.1,464.1 291.9,472.6  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M680.1,461.2c11.2,0,22.8,3.6,26,8c3.3,4.6-3.4,8.3-15,8.3c-11.6,0-23.4-3.8-26.2-8.3 C662.1,464.8,668.9,461.2,680.1,461.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M115.7,456.6l-18.1,26.2c-1.2,1.8,1.3,3.2,5.7,3.2s8.9-1.5,10-3.2l17.1-26.2c1-1.6-1.4-2.8-5.5-2.8 C120.9,453.8,116.7,455,115.7,456.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 204.9,
    cy: 475.4,
    rx: 30.3,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M204.9,355.6c-26.4,0-47.9,21.4-47.9,47.9c0,26.4,47.9,72,47.9,72s47.9-45.5,47.9-72 C252.8,377,231.4,355.6,204.9,355.6z M204.9,430.3c-14.8,0-26.9-12-26.9-26.9c0-14.8,12-26.9,26.9-26.9c14.8,0,26.9,12,26.9,26.9 C231.8,418.3,219.8,430.3,204.9,430.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M204.9,371.4c-17.7,0-32.1,14.4-32.1,32.1c0,17.7,14.4,32.1,32.1,32.1c17.7,0,32.1-14.4,32.1-32.1 C237,385.7,222.6,371.4,204.9,371.4z M204.9,425.1c-11.9,0-21.6-9.7-21.6-21.6c0-11.9,9.7-21.6,21.6-21.6s21.6,9.7,21.6,21.6 C226.6,415.4,216.9,425.1,204.9,425.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 549.5,
    cy: 533.5,
    rx: 21.7,
    ry: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M549.5,447.8c-18.9,0-34.3,15.3-34.3,34.3c0,18.9,34.3,51.5,34.3,51.5s34.3-32.6,34.3-51.5 C583.7,463.1,568.4,447.8,549.5,447.8z M549.5,501.3c-10.6,0-19.2-8.6-19.2-19.2c0-10.6,8.6-19.2,19.2-19.2 c10.6,0,19.2,8.6,19.2,19.2C568.7,492.7,560.1,501.3,549.5,501.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M549.5,459.1c-12.7,0-23,10.3-23,23c0,12.7,10.3,23,23,23c12.7,0,23-10.3,23-23 C572.4,469.4,562.1,459.1,549.5,459.1z M549.5,497.5c-8.5,0-15.5-6.9-15.5-15.5c0-8.5,6.9-15.5,15.5-15.5s15.5,6.9,15.5,15.5 C564.9,490.6,558,497.5,549.5,497.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 388.2,
    cy: 437.7,
    rx: 61.5,
    ry: 16.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M388.2,194.4c-53.7,0-97.2,43.5-97.2,97.2c0,53.7,97.2,146.2,97.2,146.2s97.2-92.5,97.2-146.2 C485.4,237.9,441.9,194.4,388.2,194.4z M388.2,346.1c-30.1,0-54.5-24.4-54.5-54.5c0-30.1,24.4-54.5,54.5-54.5 c30.1,0,54.5,24.4,54.5,54.5C442.7,321.7,418.3,346.1,388.2,346.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M388.2,226.4c-36,0-65.1,29.2-65.1,65.1c0,36,29.2,65.1,65.1,65.1c36,0,65.1-29.2,65.1-65.1 C453.3,255.6,424.2,226.4,388.2,226.4z M388.2,335.5c-24.3,0-43.9-19.7-43.9-43.9c0-24.3,19.7-43.9,43.9-43.9 c24.3,0,43.9,19.7,43.9,43.9C432.1,315.8,412.5,335.5,388.2,335.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.3,286.1c-13.1,0-23.7,10.6-23.7,23.7H593C593,296.7,582.4,286.1,569.3,286.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M460.1,295.1c-8.1,0-14.7,6.6-14.7,14.7h29.3C474.8,301.6,468.2,295.1,460.1,295.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M510.2,274.3c-19.6,0-35.4,15.9-35.4,35.4h70.9C545.7,290.2,529.8,274.3,510.2,274.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.1,303.2c-5.7,0-10.3,4.6-10.3,10.3h20.7C218.4,307.9,213.8,303.2,208.1,303.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.8,294.6c-10.5,0-18.9,8.5-18.9,18.9h37.8C197.8,303.1,189.3,294.6,178.8,294.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.2,235c-5.7,0-10.3,4.6-10.3,10.3h20.7C283.6,239.7,278.9,235,273.2,235z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244,226.4c-10.5,0-18.9,8.5-18.9,18.9h37.8C262.9,234.9,254.4,226.4,244,226.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M514.3,203c-5.7,0-10.3,4.6-10.3,10.3h20.7C524.6,207.6,520,203,514.3,203z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M485,194.4c-10.5,0-18.9,8.5-18.9,18.9H504C504,202.8,495.5,194.4,485,194.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.7,341.6c-4.4,0-8,3.6-8,8h16C286.7,345.1,283.1,341.6,278.7,341.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.2,334.9c-8.1,0-14.6,6.5-14.6,14.6h29.2C270.8,341.5,264.2,334.9,256.2,334.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M593.6,246.9c-5.7,0-10.3,4.6-10.3,10.3h20.7C603.9,251.5,599.3,246.9,593.6,246.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M564.3,238.3c-10.5,0-18.9,8.5-18.9,18.9h37.8C583.2,246.8,574.8,238.3,564.3,238.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.2,312.9h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 s0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 S258.5,312.9,258.2,312.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M291.4,329.1H290v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C292,329.4,291.8,329.1,291.4,329.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M370.7,270.3h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C371.3,270.6,371,270.3,370.7,270.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M402,277.3h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4H398c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C402.7,277.6,402.4,277.3,402,277.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M502.8,267.6h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C503.5,267.9,503.2,267.6,502.8,267.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M536,255.2h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4H532c-0.4,0-0.6,0.3-0.6,0.6 s0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6S536.4,255.2,536,255.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M480.6,228.5h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C481.2,228.8,480.9,228.5,480.6,228.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M510.3,243.1h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C510.9,243.4,510.6,243.1,510.3,243.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M576.6,240.5h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C577.2,240.8,576.9,240.5,576.6,240.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M497.5,334.9h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 s0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 S497.8,334.9,497.5,334.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M528.5,326.5h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C529.2,326.7,528.9,326.5,528.5,326.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M459.5,381.2h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6h0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 s0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6h0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6S459.9,381.2,459.5,381.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M548.8,360.9h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C549.5,361.2,549.2,360.9,548.8,360.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M559.2,309.1h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C559.8,309.4,559.5,309.1,559.2,309.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.6,280h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C241.2,280.3,241,280,240.6,280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.7,223.1h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 C289.4,223.4,289.1,223.1,288.7,223.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.8,263.2h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 s0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 S199.2,263.2,198.8,263.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.2,326.4h-1.4V325c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 s0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6v-1.4h1.4c0.4,0,0.6-0.3,0.6-0.6 S222.6,326.4,222.2,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M185.3,338.7h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 s0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6V340h1.4c0.4,0,0.6-0.3,0.6-0.6S185.7,338.7,185.3,338.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M280.2,370.7h-1.4v-1.4c0-0.4-0.3-0.6-0.6-0.6l0,0c-0.4,0-0.6,0.3-0.6,0.6v1.4h-1.4c-0.4,0-0.6,0.3-0.6,0.6 c0,0.4,0.3,0.6,0.6,0.6h1.4v1.4c0,0.4,0.3,0.6,0.6,0.6l0,0c0.4,0,0.6-0.3,0.6-0.6V372h1.4c0.4,0,0.6-0.3,0.6-0.6 C280.8,371,280.5,370.7,280.2,370.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 388.2,
    cy: 292,
    r: 37.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 204.9,
    cy: 403.5,
    r: 18.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 549.5,
    cy: 482.4,
    r: 12.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M404.6,297.5c0,9.2-7.5,16.7-16.7,16.7s-16.7-7.5-16.7-16.7c0-11.8,16.7-28.4,16.7-28.4 S404.6,285.7,404.6,297.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M197.1,405.5c0-5.3,7.9-12.9,7.9-12.9s7.9,7.6,7.9,12.9c0,4.2-3.5,7.6-7.9,7.6 C200.6,413,197.1,409.6,197.1,405.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M554.7,482.7c0,2.9-2.4,5.3-5.3,5.3s-5.3-2.4-5.3-5.3c0-3.8,5.3-9.1,5.3-9.1S554.7,478.9,554.7,482.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.2451ca068426954664bd643dfb6f5bef.svg";
export { ForwardRef as ReactComponent };